import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Giả lập API đọc file
declare global {
  interface Window {
    fs: {
      readFile(path: string, options?: { encoding?: string }): Promise<any>;
    }
  }
}

if (typeof window !== 'undefined' && !window.fs) {
  window.fs = {
    async readFile(path: string, options?: { encoding?: string }) {
      try {
        const response = await fetch(`/data/${path}`);
        
        if (!response.ok) {
          throw new Error(`Failed to load file: ${path}`);
        }
        
        if (options?.encoding === 'utf8') {
          return await response.text();
        }
        
        return await response.arrayBuffer();
      } catch (error) {
        console.error("Error reading file:", error);
        throw error;
      }
    }
  };
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();